// Helper function to get VIP icon based on level
export const getVIPIcon = (level: number, isVIP: boolean = true) => {
    if (!isVIP) return ''
    if (level === 1) return '👑'
    return `👑${level}`
}
